import React, { Component } from 'react';
import DefaultNavbar from '../navigation/defaultnavbar.jsx'
import Activate from './activate.jsx'
import '../../stylesheet/activate.css'

class componentName extends Component {
    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 p-0 m-0">
                        <DefaultNavbar />
                    </div>

                </div>
                <div className='col-md-12'>
                    <div className="container p-4" style={{ marginBottom: "60px" }}>
                        <div className="row">
                            <div className=" col-sm-12 p-0 m-0">
                                <Activate />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

export default componentName;


// WEBPACK FOOTER //
// ./src/components/register/navactivate.jsx